import { openWorkspaceDb } from '@/offline/db'
import { atomicLocalWrite, buildOperation } from '@/offline/queue'
import { pushOutbox, type PushSummary } from '@/offline/sync'
import { supabaseTransport } from '@/offline/transport'
import type { BuiltExpense } from './expensePayload'

export async function saveExpense(workspaceId: string, built: BuiltExpense): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)
  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.expense.id,
    entity_type: 'expense',
    expected_revision: null,
    action: 'expense.create',
    payload: built.payload,
  })
  await atomicLocalWrite(db, [db.expenses], async () => {
    await db.expenses.add(built.expense)
  }, op)
  return pushOutbox(db, supabaseTransport())
}
